import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import NavMenu from "../../components/createForm/SchoolBusNavMenu";
import SchoolDashboardDatas from "../../components/dashboard/SchoolDashboard";
import { Box } from "@mui/material";
export default function Dashboard() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        <NavMenu />
        <SchoolDashboardDatas dashboard />
      </Box>
      <Footer />
    </Box>
  );
}
